import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteWeatherAlert = (alertId: number) => {
  return axios.delete(`/api/weather/alerts/${alertId}`);
};

type UseDeleteWeatherAlertOptions = {
  config?: MutationConfig<typeof deleteWeatherAlert>;
};

export const useDeleteWeatherAlert = ({
  config,
}: UseDeleteWeatherAlertOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherAlerts) {
        queryClient.setQueryData(
          ['weatherAlerts'],
          context.previousWeatherAlerts
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherAlerts']);
      queryClient.invalidateQueries(['dishes']);
    },
    ...config,
    mutationFn: deleteWeatherAlert,
  });
};
